import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DailyAggregate } from '@etiquetachef/types';
import { formatInt, formatYyyymmddDisplay } from '../formatters';
import { BiTimeChart } from './BiTimeChart';

/**
 * Etiquetas impressas por dia (`labels.printedToday` do agregado diário); `null` vira 0 no
 * gráfico — o dado ausente só é distinguido no KPI, não aqui.
 *
 * Origem: sem issue — commit 85642b993, 2026-05-04 15:56 +0200.
 * Usado por: `FinanceDashboardPage` (rota `/dashboard/finance`, `apps/admin`).
 *
 * Histórico:
 *  - 2026-10-10 14:40 +0200 — (#798) cabeçalho padrão (#796).
 */
export function LabelsChart({ series }: { series: readonly DailyAggregate[] }): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({
    x: formatYyyymmddDisplay(d.yyyymmdd),
    y: d.labels.printedToday ?? 0,
  }));
  return (
    <BiTimeChart
      title={t('finance.charts.labels')}
      subtitle={t('finance.charts.labelsHelper')}
      type="line"
      data={data}
      color="#9333ea"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
